<template>
    <footer v-if="!isMobile" class="order-footer">
        <div>
            <button class="btn btn-icon-left btn-light text-uppercase" @click="back">
                <span class="material-icon icon-keyboard_arrow_left"></span>
                {{ $t('back') }}
            </button>
        </div>
        <div v-if="!showCropper && !showFilters && album && (+album.allow_clipping || +album.allow_filters)">
            <a href="#" v-if="+album.allow_clipping" class="btn btn-link order-footer-btn order-footer-btn--dir-col" @click.prevent="$emit('show-cropper')">
                <span class="material-icon icon-crop_rotate"/>
                {{ $t('transform') }}
            </a>
            <a href="#" v-if="+album.allow_filters" class="btn btn-link order-footer-btn order-footer-btn--dir-col" @click.prevent="$emit('show-filters')">
                <span class="material-icon icon-colorize"/>
                {{ $t('filter') }}
            </a>
        </div>
        <div v-if="showCropper">
            <a href="#" id="flip-x" class="btn btn-link order-footer-btn order-footer-btn--dir-col" @click.prevent="$emit('control', 'flip')">
                <span class="material-icon icon-flip"/>
                <span v-html="$t('photo_editor.flip')"></span>
            </a>
            <a href="#" class="btn btn-link order-footer-btn order-footer-btn--dir-col" @click.prevent="$emit('control', 'landscape')">
                <span class="material-icon icon-crop_5_4"/>
                {{ $t('photo_editor.crop_landscape') }}
            </a>
            <a href="#" class="btn btn-link order-footer-btn order-footer-btn--dir-col" @click.prevent="$emit('control', 'portrait')">
                <span class="material-icon icon-crop_portrait"/>
                {{ $t('photo_editor.crop_portrait') }}
            </a>
        </div>
        <div v-if="showFilters">
            <ul v-if="filters" class="order-footer-filters">
                <li :class="['order-footer-filters__item', {'order-footer-filters__item--active': !activeFilter}]" @click="setFilter(null)"></li>
                <li :class="['order-footer-filters__item', {'order-footer-filters__item--active': activeFilter && activeFilter.name === filter.name}]" v-for="(filter, i) in filters" :key="i" :ref="filter.name" @click="setFilter(filter)"></li>
            </ul>
        </div>
        <div>
            <button class="btn btn-success btn-shadow text-uppercase" v-if="!showCropper && !showFilters" @click="$emit('modify')">
                {{ $t('save') }}
            </button>
            <template v-if="showCropper">
                <button class="btn btn-light btn-icon-left text-uppercase mr-3" @click="$emit('reset-crop')">
                    <span class="material-icon icon-undo"></span>
                    {{ $t('cancel') }}
                </button>
                <button class="btn btn-success btn-shadow text-uppercase" @click="$emit('crop')">
                    {{ $t('confirm') }}
                </button>
            </template>
            <template v-if="showFilters">
                <button class="btn btn-light btn-icon-left text-uppercase mr-3" @click="resetFilter">
                    <span class="material-icon icon-undo"></span>
                    {{ $t('cancel') }}
                </button>
                <button class="btn btn-success btn-shadow text-uppercase" @click="$emit('set-filter', activeFilter)">
                    {{ $t('confirm') }}
                </button>
            </template>
        </div>
    </footer>
    <div v-else class="mobile-menu mobile-menu--transparent">
        <ul class="mobile-menu__actions">
            <template v-if="showCropper">
                <li class="mobile-menu__action">
                    <a href="#" id="flip-x" class="action-link" @click.prevent="$emit('control', 'flip')">
                        <span class="material-icon icon-flip"/>
                        <span class="action-link__txt">{{ $t('photo_editor.flip') }}</span>
                    </a>
                </li>
                <li class="mobile-menu__action">
                    <a href="#" class="action-link" @click.prevent="$emit('control', 'landscape')">
                        <span class="material-icon icon-crop_5_4"/>
                        <span class="action-link__txt">{{ $t('photo_editor.crop_landscape') }}</span>
                    </a>
                </li>
                <li class="mobile-menu__action">
                    <a href="#" class="action-link" @click.prevent="$emit('control', 'portrait')">
                        <span class="material-icon icon-crop_portrait"/>
                        <span class="action-link__txt">{{ $t('photo_editor.crop_portrait') }}</span>
                    </a>
                </li>
            </template>
            <template v-else>
                <li v-if="!mobileFilterMenu" class="mobile-menu__action mobile-menu__action-back-btn">
                    <a href="#" class="action-link" @click.prevent="back">
                        <span class="material-icon icon-keyboard_arrow_left"/>
                    </a>
                </li>
                <li class="mobile-menu__action">
                    <a href="#" class="action-link" @click.prevent="$emit('show-cropper'), $store.dispatch('SET_MOBILE_CROPPER_MENU', true)">
                        <span class="material-icon icon-crop_rotate"/>
                        <span class="action-link__txt">{{ $t('transform') }}</span>
                    </a>
                </li>
                <li class="mobile-menu__action">
                    <div class="mobile-common-menu">
                        <template v-if="mobileFilterMenu">
                            <div class="mobile-common-menu__container js-mobile-menu-container">
                                <div class="mobile-common-menu__container-inner">
                                    <div class="mobile-common-menu__content">
                                        <p class="text-center mb-3 text-uppercase">{{ $t('filters') }}</p>
                                        <ul v-if="filters" class="order-footer-filters">
                                            <li :class="['order-footer-filters__item', {'order-footer-filters__item--active': !activeFilter}]" @click="setFilter(null, true)"></li>
                                            <li :class="['order-footer-filters__item', {'order-footer-filters__item--active': activeFilter && activeFilter.name === filter.name}]" v-for="(filter, i) in filters" :key="i" :ref="filter.name" @click="setFilter(filter, true)"></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <a href="#" @click.prevent="$store.dispatch('SET_MOBILE_FILTER_MENU', false)" class="mobile-common-menu__btn -red">
                                <span class="material-icon icon-clear"/>
                            </a>
                        </template>
                        <a v-else href="#" @click.prevent="$store.dispatch('SET_MOBILE_FILTER_MENU', true)" class="action-link">
                            <span class="material-icon icon-colorize"/>
                            <span class="action-link__txt">{{ $t('filter') }}</span>
                        </a>
                    </div>
                </li>
            </template>
        </ul>
        <a href="#" v-if="!mobileFilterMenu && !mobileCropperMenu" @click.prevent="$emit('modify')" class="mobile-menu__btn -green">
            <span class="material-icon icon-check"/>
        </a>
        <a href="#" v-else-if="mobileCropperMenu" @click.prevent="$emit('crop'), $store.dispatch('SET_MOBILE_CROPPER_MENU', false)" class="mobile-menu__btn -green">
            <span class="material-icon icon-check"/>
        </a>
    </div>
</template>

<script>
  import photoEditorFooter from 'src/mixins/photoEditorFooterComponent';

  export default {
    mixins: [photoEditorFooter],
  };
</script>